/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneValues/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelectOneValue from './TysiaSelectOneValue/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneValues({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneValues",
  marginTop,
  tagsWidth = "auto",
  selected,
  size,
  backgroundColor,
  borderColor,
  color,
  onClick,
  disabled
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let marginTopOrdtSpaceXs = marginTop ?? dtSpaceXs
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOneValues.List"
  data-view-path={viewPath}
 style={{'--w-2-vinoS': typeof tagsWidth === 'number' ? `${tagsWidth}px` : tagsWidth,'--mt-1-vinoS': size === "small" ? typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs : typeof marginTopOrdtSpaceXs === 'number' ? `${marginTopOrdtSpaceXs}px` : marginTopOrdtSpaceXs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(selected) && selected.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="tysia_select_one_value"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/TysiaSelectOneValue(${item?.id ?? item?._id ?? index})`}
      >
<TysiaSelectOneValue
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/TysiaSelectOneValue(${item?.id ?? item?._id ?? index})`}
 backgroundColor={backgroundColor}
 borderColor={borderColor}
 color={color}
 onClick={onClick}
 size={size}
 disabled={disabled}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }